function scrollToId(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
}

const heroTags = ["匿名投稿", "图文瓜料", "吧友在线审核", "三步上首页"];

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative overflow-hidden bg-background-100"
      aria-label="首屏介绍"
    >
      {/* 背景装饰 */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.12]"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=retro%20newsprint%20newspaper%20collage%20texture%20with%20old%20headline%20clippings%20and%20starburst%20badges%20scattered%20gossip%20magazine%20scrapbook%20warm%20cream%20background%20scattered%20typewriter%20text%20and%20phone%20frames%20vintage%20editorial%20style%2C%20orange%20and%20black%20ink%20on%20beige%20paper&width=1600&height=900&seq=hero-bg-baoliao&orientation=landscape')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>

      <div className="relative mx-auto flex min-h-[560px] w-full flex-col items-center justify-center px-4 pb-16 pt-28 text-center md:min-h-[680px] md:px-6 md:pb-24 md:pt-32">
        {/* 顶部爆款标签 */}
        <div className="mb-6 flex flex-wrap items-center justify-center gap-2">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-4 py-1.5 text-sm font-bold text-foreground-950">
            <i className="ri-flag-2-fill text-base" aria-hidden="true"></i>
            吃瓜现场 · 投稿入口已开放
          </span>
        </div>

        <h1 className="font-serifsc text-4xl font-black leading-tight tracking-tight text-foreground-950 md:text-6xl lg:text-7xl">
          有话想爆料？
          <br />
          <span className="relative inline-block text-primary-600">
            来爆料吧说给所有人听
            <span className="absolute -bottom-2 left-0 h-3 w-full -rotate-1 bg-accent-400/60 md:-bottom-3" aria-hidden="true"></span>
          </span>
        </h1>

        <p className="mt-8 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
          想发帖爆料却找不到地方？爆料吧投稿入口正式开放，支持匿名投稿与图文格式。
          吧友在线审核，热门瓜第一时间登上首页。三步完成发帖爆料，你的故事值得被看见。
        </p>

        {/* CTA */}
        <div className="mt-10 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#submit"
            onClick={(e) => {
              e.preventDefault();
              scrollToId("submit");
            }}
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-8 py-4 text-base font-bold text-white transition-transform hover:scale-105 sm:w-auto"
          >
            <i className="ri-send-plane-fill text-lg" aria-hidden="true"></i>
            马上匿名投稿
          </a>
          <a
            href="#how"
            onClick={(e) => {
              e.preventDefault();
              scrollToId("how");
            }}
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border-2 border-foreground-950 bg-background-50 px-8 py-4 text-base font-bold text-foreground-950 transition-colors hover:bg-foreground-950 hover:text-background-50 sm:w-auto"
          >
            看投稿教程
            <i className="ri-arrow-down-line text-lg" aria-hidden="true"></i>
          </a>
        </div>

        {/* 特性标签 */}
        <div className="mt-10 flex flex-wrap items-center justify-center gap-2 md:gap-3">
          {heroTags.map((tag) => (
            <span
              key={tag}
              className="inline-flex items-center gap-1.5 rounded-full bg-background-50/90 px-4 py-2 text-sm font-medium text-foreground-800 ring-1 ring-background-200"
            >
              <i className="ri-checkbox-circle-line text-base text-primary-500" aria-hidden="true"></i>
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}